import type { Configuration } from '@repo/api-gw-sdk';
import { GetControlPlaneConfigApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/control-plane/config';

export const controlPlaneConfig = (
  httpClient: HttpClient,
  config: Configuration
) => {
  const controlPlaneConfigApi = new GetControlPlaneConfigApi(config);

  return {
    useGet: (enabled = true) =>
      httpClient.execute(
        controlPlaneConfigApi.getControlPlaneConfig.bind(controlPlaneConfigApi),
        enabled ? baseUrl : null,
        ''
      ),
  };
};
